namespace advisorop.components.servicer {

    interface IServicerNavController {
        $router;
    }

    class ServicerNavController implements IServicerNavController {

        $router;  
        user: domains.identity.IUser = {};
        counters = {
            numberOfAllAlerts: 0,
            numberOfRmTasks: 0,
            numberOfWfTasks: 0,
            numberOfUsertEntryTasks: 0
        } as domains.IAlertCounters;

        isNotATrader: boolean = false;
        showRmdTrackerNew: boolean = false;

        static $inject = ["identityService", "generalService", "$rootScope"];        
        constructor(private identityService: services.IdentityService,
            private generalService: services.GeneralService,
            private $rootScope: ng.IRootScopeService) {

            this.$rootScope.$on('alertCounterChanged', (event: ng.IAngularEvent) => {
                this.counters = this.generalService.getAlertCounters();
            });
        }

        logout(): void {
            this.$router.parent.navigate(["Account", "Logout"]);
        }

        isServicerAdmin(): boolean {
            return (this.user.role == domains.AdvisoryRoles.SERVICER_ADMIN.toString());
        }

        isTrader(): boolean {
            return (this.user.role == domains.AdvisoryRoles.SERVICER_TRADER.toString());
        }

        // Only the single system administrator account sees the maintenance menu item.
        isSystemAdmin(): boolean {
            return (this.user.username == "00000001");
        }

        $onInit(): void {
            this.identityService.getUserPromise().then(response => {
                this.user = response;
                this.isNotATrader = !this.isTrader();
            });

            this.generalService.refreshAlertCounters();

            // Hidden until the answer arrives, and if it never does.
            this.generalService.getRmdTrackerMenuVisible()
                .then(response => this.showRmdTrackerNew = response.data === true);
        }

        $routerOnActivate(next, previous) {
        }
    }



    class ServicerNav implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = {
                "$router": "<"
            };
            this.controller = ServicerNavController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/servicer-nav.html';
        }
    }
    angular.module(Constants.APP).component("servicerNav", new ServicerNav());
}